import type { IWalletCurrencyTagIconProps } from './helpers';

export const WalletCurrencyTagIcon = ({ variant, ...rest }: IWalletCurrencyTagIconProps) => {
	if (variant === 'NGN')
		return (
			<svg
				width='101'
				height='24'
				viewBox='0 0 101 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.25'
					y='0.25'
					width='100.5'
					height='23.5'
					rx='11.75'
					fill='#F7F8F8'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='100.5'
					height='23.5'
					rx='11.75'
					stroke='#ECEEEE'
					strokeWidth='0.5'
				/>
				<g clipPath='url(#clip0_8609_50199)'>
					<rect
						x='8'
						y='5'
						width='14'
						height='14'
						rx='7'
						fill='white'
					/>
					<rect
						x='6.29167'
						y='5.29167'
						width='18.0833'
						height='13.4167'
						rx='2.04167'
						fill='white'
						stroke='#F5F5F5'
						strokeWidth='0.583333'
					/>
					<mask
						id='mask0_8609_50199'
						style={{ maskType: 'luminance' }}
						maskUnits='userSpaceOnUse'
						x='6'
						y='5'
						width='19'
						height='14'
					>
						<rect
							x='6.29167'
							y='5.29167'
							width='18.0833'
							height='13.4167'
							rx='2.04167'
							fill='white'
							stroke='white'
							strokeWidth='0.583333'
						/>
					</mask>
					<g mask='url(#mask0_8609_50199)'>
						<rect
							x='18.4443'
							y='5'
							width='6.22222'
							height='14'
							fill='#189B62'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6 19H12.2222V5H6V19Z'
							fill='#189B62'
						/>
					</g>
				</g>
				<path
					d='M33.2565 7.84H34.2045V16H33.4125L28.1925 9.568V16H27.2445V7.84H28.0125L33.2565 14.356V7.84ZM40.356 10.432H41.268V16H40.356V15.424C39.864 15.88 39.192 16.144 38.4 16.144C36.804 16.144 35.532 14.848 35.532 13.216C35.532 11.596 36.804 10.288 38.4 10.288C39.192 10.288 39.864 10.552 40.356 11.008V10.432ZM38.52 15.304C39.252 15.304 39.9 15.028 40.356 14.356V12.076C39.9 11.404 39.252 11.128 38.52 11.128C37.344 11.128 36.444 12.064 36.444 13.216C36.444 14.368 37.344 15.304 38.52 15.304ZM43.37 8.944C43.022 8.944 42.758 8.68 42.758 8.344C42.758 7.996 43.022 7.732 43.37 7.732C43.718 7.732 43.994 7.996 43.994 8.344C43.994 8.68 43.718 8.944 43.37 8.944ZM42.926 10.432H43.838V16H42.926V10.432ZM46.3775 11.344C46.8935 10.684 47.6375 10.3 48.5255 10.3V11.164C47.6135 11.188 46.8695 11.608 46.3775 12.376V16H45.4655V10.432H46.3775V11.344ZM53.6816 10.432H54.5936V16H53.6816V15.424C53.1896 15.88 52.5176 16.144 51.7256 16.144C50.1296 16.144 48.8576 14.848 48.8576 13.216C48.8576 11.596 50.1296 10.288 51.7256 10.288C52.5176 10.288 53.1896 10.552 53.6816 11.008V10.432ZM51.8456 15.304C52.5776 15.304 53.2256 15.028 53.6816 14.356V12.076C53.2256 11.404 52.5776 11.128 51.8456 11.128C50.6696 11.128 49.7696 12.064 49.7696 13.216C49.7696 14.368 50.6696 15.304 51.8456 15.304ZM59.558 12.352C59.558 14.356 60.302 15.664 61.622 16.888L61.034 17.488C59.45 16.192 58.622 14.452 58.622 12.352C58.622 10.264 59.45 8.524 61.034 7.228L61.622 7.828C60.302 9.04 59.558 10.36 59.558 12.352ZM68.6856 7.84H69.6336V16H68.8416L63.6216 9.568V16H62.6736V7.84H63.4416L68.6856 14.356V7.84ZM75.1731 11.692H79.2171V16H78.4491L78.3771 14.332C77.7891 15.424 76.7451 16.144 75.2571 16.144C72.8451 16.144 71.0331 14.272 71.0331 11.98C71.0331 9.508 72.9411 7.696 75.3171 7.696C77.0931 7.696 78.7371 8.716 79.1931 10.54H78.1731C77.7651 9.22 76.5291 8.584 75.3291 8.584C73.4451 8.584 71.9931 10 71.9931 11.98C71.9931 13.756 73.3491 15.256 75.2571 15.256C76.9251 15.256 77.9811 14.092 78.2091 12.568H75.1731V11.692ZM87.1084 7.84H88.0564V16H87.2644L82.0444 9.568V16H81.0964V7.84H81.8644L87.1084 14.356V7.84ZM89.6959 7.228C91.2799 8.524 92.1079 10.264 92.1079 12.352C92.1079 14.452 91.2799 16.192 89.6959 17.488L89.1079 16.888C90.4279 15.664 91.1719 14.356 91.1719 12.352C91.1719 10.36 90.4279 9.04 89.1079 7.828L89.6959 7.228Z'
					fill='#022745'
				/>
				<defs>
					<clipPath id='clip0_8609_50199'>
						<rect
							x='8'
							y='5'
							width='14'
							height='14'
							rx='7'
							fill='white'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	if (variant === 'GHS')
		return (
			<svg
				width='101'
				height='24'
				viewBox='0 0 101 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					x='0.25'
					y='0.25'
					width='100.5'
					height='23.5'
					rx='11.75'
					fill='#F7F8F8'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='100.5'
					height='23.5'
					rx='11.75'
					stroke='#ECEEEE'
					strokeWidth='0.5'
				/>
				<g clipPath='url(#clip0_8609_50316)'>
					<rect
						x='8'
						y='5'
						width='14'
						height='14'
						rx='7'
						fill='white'
					/>
					<rect
						x='6'
						y='5'
						width='18.6667'
						height='14'
						rx='2.33333'
						fill='white'
					/>
					<mask
						id='mask0_8609_50316'
						style={{ maskType: 'luminance' }}
						maskUnits='userSpaceOnUse'
						x='6'
						y='5'
						width='19'
						height='14'
					>
						<rect
							x='6'
							y='5'
							width='18.6667'
							height='14'
							rx='2.33333'
							fill='white'
						/>
					</mask>
					<g mask='url(#mask0_8609_50316)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6 9.66667H24.6667V5H6V9.66667Z'
							fill='#E71F37'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6 19.0007H24.6667V14.334H6V19.0007Z'
							fill='#118B56'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6 14.3327H24.6667V9.66602H6V14.3327Z'
							fill='#FDD64C'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M15.3336 13.1286L14.0274 14.1214L14.523 12.5102L13.2201 11.5127L14.8326 11.5098L15.3336 9.90039L15.8345 11.5098L17.447 11.5127L16.1441 12.5102L16.6397 14.1214L15.3336 13.1286Z'
							fill='#262626'
						/>
					</g>
				</g>
				<path
					d='M31.0683 15.268C32.5563 15.268 33.6363 14.404 33.9723 13.084H34.9563C34.5723 14.92 33.0723 16.156 31.0683 16.156C28.7163 16.156 26.8203 14.332 26.8203 11.92C26.8203 9.508 28.7163 7.696 31.0683 7.696C33.0723 7.696 34.5723 8.92 34.9563 10.756H33.9723C33.6363 9.424 32.5563 8.584 31.0683 8.584C29.2203 8.584 27.7803 10.012 27.7803 11.92C27.7803 13.828 29.2203 15.268 31.0683 15.268ZM38.5814 10.288C40.3694 10.288 41.4854 11.668 41.3054 13.492H36.6494C36.7574 14.524 37.4654 15.328 38.6294 15.328C39.3374 15.328 39.8774 15.076 40.1174 14.608H41.1374C40.7894 15.568 39.8294 16.144 38.6294 16.144C36.9134 16.144 35.7254 14.86 35.7254 13.216C35.7254 11.572 36.9014 10.288 38.5814 10.288ZM38.5814 11.08C37.4774 11.08 36.7934 11.86 36.6614 12.844H40.3934C40.3454 11.74 39.6374 11.08 38.5814 11.08ZM47.0655 7.48H47.9775V16H47.0655V15.424C46.5735 15.88 45.9015 16.144 45.1095 16.144C43.5135 16.144 42.2415 14.836 42.2415 13.216C42.2415 11.584 43.5135 10.288 45.1095 10.288C45.9015 10.288 46.5735 10.552 47.0655 11.008V7.48ZM45.2295 15.304C45.9615 15.304 46.6095 15.028 47.0655 14.356V12.076C46.6095 11.404 45.9615 11.128 45.2295 11.128C44.0535 11.128 43.1535 12.064 43.1535 13.216C43.1535 14.368 44.0535 15.304 45.2295 15.304ZM50.0794 8.944C49.7314 8.944 49.4674 8.68 49.4674 8.344C49.4674 7.996 49.7314 7.732 50.0794 7.732C50.4274 7.732 50.7034 7.996 50.7034 8.344C50.7034 8.68 50.4274 8.944 50.0794 8.944ZM49.6354 10.432H50.5474V16H49.6354V10.432ZM52.5492 14.248C52.7172 14.992 53.2932 15.388 54.3132 15.388C55.1772 15.388 55.7652 15.064 55.7652 14.5C55.7652 14.032 55.3932 13.756 54.8532 13.66L53.5932 13.456C52.6812 13.3 51.9372 12.892 51.9372 11.944C51.9372 10.912 52.8492 10.288 54.1932 10.288C55.3572 10.288 56.5092 10.732 56.6172 12.052H55.7652C55.6692 11.356 55.0812 11.032 54.1932 11.032C53.3532 11.032 52.8492 11.356 52.8492 11.86C52.8492 12.268 53.1252 12.568 53.8812 12.7L54.9852 12.88C55.7892 13.012 56.6412 13.372 56.6412 14.44C56.6412 15.532 55.6572 16.144 54.2892 16.144C52.8732 16.144 51.8652 15.556 51.6972 14.248H52.5492ZM61.3803 12.352C61.3803 14.356 62.1243 15.664 63.4443 16.888L62.8563 17.488C61.2723 16.192 60.4443 14.452 60.4443 12.352C60.4443 10.264 61.2723 8.524 62.8563 7.228L63.4443 7.828C62.1243 9.04 61.3803 10.36 61.3803 12.352ZM68.0535 11.692H72.0975V16H71.3295L71.2575 14.332C70.6695 15.424 69.6255 16.144 68.1375 16.144C65.7255 16.144 63.9135 14.272 63.9135 11.98C63.9135 9.508 65.8215 7.696 68.1975 7.696C69.9735 7.696 71.6175 8.716 72.0735 10.54H71.0535C70.6455 9.22 69.4095 8.584 68.2095 8.584C66.3255 8.584 64.8735 10 64.8735 11.98C64.8735 13.756 66.2295 15.256 68.1375 15.256C69.8055 15.256 70.8615 14.092 71.0895 12.568H68.0535V11.692ZM79.7128 7.84H80.6608V16H79.7128V12.4H74.9248V16H73.9768V7.84H74.9248V11.524H79.7128V7.84ZM85.2708 7.696C86.8788 7.696 88.2708 8.404 88.4748 10.084H87.5268C87.3468 9.112 86.6628 8.512 85.3308 8.512C84.1308 8.512 83.3508 9.052 83.3508 9.976C83.3508 10.696 83.8668 11.104 84.8388 11.296L86.1708 11.548C87.6348 11.836 88.4628 12.496 88.4628 13.696C88.4628 15.184 87.2388 16.144 85.4028 16.144C83.4468 16.144 82.1748 15.148 81.9948 13.384H82.9308C83.1228 14.608 83.9988 15.292 85.4508 15.292C86.6988 15.292 87.4908 14.728 87.4908 13.804C87.4908 13.156 87.0468 12.652 86.0148 12.472L84.4908 12.172C83.0388 11.896 82.3428 11.152 82.3428 10.036C82.3428 8.608 83.5188 7.696 85.2708 7.696ZM89.7721 7.228C91.3561 8.524 92.1841 10.264 92.1841 12.352C92.1841 14.452 91.3561 16.192 89.7721 17.488L89.1841 16.888C90.5041 15.664 91.2481 14.356 91.2481 12.352C91.2481 10.36 90.5041 9.04 89.1841 7.828L89.7721 7.228Z'
					fill='#022745'
				/>
				<defs>
					<clipPath id='clip0_8609_50316'>
						<rect
							x='8'
							y='5'
							width='14'
							height='14'
							rx='7'
							fill='white'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	return (
		<svg
			width='100'
			height='24'
			viewBox='0 0 100 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				x='0.25'
				y='0.25'
				width='99.5'
				height='23.5'
				rx='11.75'
				fill='#F7F8F8'
			/>
			<rect
				x='0.25'
				y='0.25'
				width='99.5'
				height='23.5'
				rx='11.75'
				stroke='#ECEEEE'
				strokeWidth='0.5'
			/>
			<g clipPath='url(#clip0_8609_50280)'>
				<rect
					x='8'
					y='5'
					width='14'
					height='14'
					rx='7'
					fill='white'
				/>
				<rect
					x='6'
					y='5'
					width='18.6667'
					height='14'
					rx='2.33333'
					fill='white'
				/>
				<mask
					id='mask0_8609_50280'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='6'
					y='5'
					width='19'
					height='14'
				>
					<rect
						x='6'
						y='5'
						width='18.6667'
						height='14'
						rx='2.33333'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask0_8609_50280)'>
					<path
						d='M24.667 19H6V18.0664H24.667V19ZM24.667 17.1338H6V16.2002H24.667V17.1338ZM24.667 15.2666H6V14.333H24.667V15.2666ZM24.667 13.4004H6V12.4668H24.667V13.4004ZM24.667 11.5332H6V10.5996H24.667V11.5332ZM24.667 9.66699H6V8.7334H24.667V9.66699ZM24.667 7.7998H6V6.86621H24.667V7.7998ZM24.667 5.93359H6V5H24.667V5.93359Z'
						fill='#D02F44'
					/>
					<rect
						x='6'
						y='5'
						width='8'
						height='6.53333'
						fill='#46467F'
					/>
					<g filter='url(#filter0_d_8609_50280)'>
						<path
							d='M7.33301 9.66699C7.57847 9.66699 7.77734 9.87606 7.77734 10.1338C7.77724 10.3914 7.57841 10.6006 7.33301 10.6006C7.08766 10.6005 6.88877 10.3914 6.88867 10.1338C6.88867 9.87609 7.0876 9.66705 7.33301 9.66699ZM9.11133 9.66699C9.35659 9.66724 9.55566 9.87621 9.55566 10.1338C9.55556 10.3913 9.35653 10.6003 9.11133 10.6006C8.86593 10.6006 8.66612 10.3914 8.66602 10.1338C8.66602 9.87606 8.86587 9.66699 9.11133 9.66699ZM10.8887 9.66699C11.1341 9.66699 11.333 9.87606 11.333 10.1338C11.3329 10.3914 11.1341 10.6006 10.8887 10.6006C10.6433 10.6006 10.4444 10.3914 10.4443 10.1338C10.4443 9.87606 10.6432 9.66699 10.8887 9.66699ZM12.666 9.66699C12.9115 9.66699 13.1113 9.87606 13.1113 10.1338C13.1112 10.3914 12.9114 10.6006 12.666 10.6006C12.4208 10.6003 12.2218 10.3913 12.2217 10.1338C12.2217 9.87621 12.4208 9.66724 12.666 9.66699ZM8.22168 8.7334C8.46712 8.7334 8.66598 8.94249 8.66602 9.2002C8.66602 9.45793 8.46714 9.66699 8.22168 9.66699C7.97637 9.66681 7.77734 9.45781 7.77734 9.2002C7.77738 8.94261 7.97639 8.73358 8.22168 8.7334ZM10 8.7334C10.2453 8.73352 10.4443 8.94257 10.4443 9.2002C10.4443 9.45785 10.2454 9.66687 10 9.66699C9.75454 9.66699 9.55566 9.45793 9.55566 9.2002C9.5557 8.94249 9.75456 8.7334 10 8.7334ZM11.7773 8.7334C12.0228 8.7334 12.2216 8.94249 12.2217 9.2002C12.2217 9.45793 12.0228 9.66699 11.7773 9.66699C11.532 9.66687 11.333 9.45785 11.333 9.2002C11.333 8.94257 11.532 8.73352 11.7773 8.7334ZM7.33301 7.7998C7.57836 7.7998 7.77718 8.00902 7.77734 8.2666C7.77734 8.52433 7.57847 8.7334 7.33301 8.7334C7.0876 8.73334 6.88867 8.5243 6.88867 8.2666C6.88884 8.00906 7.0877 7.79987 7.33301 7.7998ZM9.11133 7.7998C9.35649 7.80005 9.5555 8.00917 9.55566 8.2666C9.55566 8.52418 9.35659 8.73315 9.11133 8.7334C8.86587 8.7334 8.66602 8.52433 8.66602 8.2666C8.66618 8.00902 8.86597 7.7998 9.11133 7.7998ZM10.8887 7.7998C11.134 7.7998 11.3328 8.00902 11.333 8.2666C11.333 8.52433 11.1341 8.7334 10.8887 8.7334C10.6432 8.7334 10.4443 8.52433 10.4443 8.2666C10.4445 8.00902 10.6433 7.7998 10.8887 7.7998ZM12.666 7.7998C12.9114 7.7998 13.1112 8.00902 13.1113 8.2666C13.1113 8.52433 12.9115 8.7334 12.666 8.7334C12.4208 8.73315 12.2217 8.52418 12.2217 8.2666C12.2218 8.00917 12.4209 7.80005 12.666 7.7998ZM8.22168 6.86719C8.46714 6.86719 8.66602 7.07625 8.66602 7.33398C8.66581 7.59154 8.46702 7.7998 8.22168 7.7998C7.97649 7.79962 7.77754 7.59142 7.77734 7.33398C7.77734 7.07637 7.97637 6.86737 8.22168 6.86719ZM10 6.86719C10.2454 6.86731 10.4443 7.07633 10.4443 7.33398C10.4441 7.59146 10.2452 7.79968 10 7.7998C9.75466 7.7998 9.55587 7.59154 9.55566 7.33398C9.55566 7.07625 9.75454 6.86719 10 6.86719ZM11.7773 6.86719C12.0228 6.86719 12.2217 7.07625 12.2217 7.33398C12.2215 7.59154 12.0227 7.7998 11.7773 7.7998C11.5321 7.79968 11.3332 7.59146 11.333 7.33398C11.333 7.07633 11.532 6.86731 11.7773 6.86719ZM7.33301 5.93359C7.57847 5.93359 7.77734 6.14266 7.77734 6.40039C7.77728 6.65806 7.57843 6.86719 7.33301 6.86719C7.08764 6.86713 6.88874 6.65803 6.88867 6.40039C6.88867 6.1427 7.0876 5.93366 7.33301 5.93359ZM9.11133 5.93359C9.35659 5.93384 9.55566 6.14281 9.55566 6.40039C9.5556 6.65791 9.35655 6.86694 9.11133 6.86719C8.86591 6.86719 8.66608 6.65806 8.66602 6.40039C8.66602 6.14266 8.86587 5.93359 9.11133 5.93359ZM10.8887 5.93359C11.1341 5.93359 11.333 6.14266 11.333 6.40039C11.3329 6.65806 11.1341 6.86719 10.8887 6.86719C10.6433 6.86719 10.4444 6.65806 10.4443 6.40039C10.4443 6.14266 10.6432 5.93359 10.8887 5.93359ZM12.666 5.93359C12.9115 5.93359 13.1113 6.14266 13.1113 6.40039C13.1113 6.65806 12.9114 6.86719 12.666 6.86719C12.4208 6.86694 12.2217 6.65791 12.2217 6.40039C12.2217 6.14281 12.4208 5.93384 12.666 5.93359Z'
							fill='url(#paint0_linear_8609_50280)'
						/>
					</g>
				</g>
			</g>
			<path
				d='M30.292 7.84C32.812 7.84 34.6 9.508 34.6 11.86C34.6 14.284 32.812 16 30.292 16H27.424V7.84H30.292ZM30.292 15.124C32.236 15.124 33.628 13.768 33.628 11.86C33.628 10.036 32.236 8.716 30.292 8.716H28.372V15.124H30.292ZM38.3356 10.288C40.0276 10.288 41.2876 11.536 41.2876 13.216C41.2876 14.896 40.0276 16.144 38.3356 16.144C36.6316 16.144 35.3716 14.896 35.3716 13.216C35.3716 11.536 36.6316 10.288 38.3356 10.288ZM38.3356 15.304C39.4996 15.304 40.3636 14.416 40.3636 13.216C40.3636 12.016 39.4996 11.128 38.3356 11.128C37.1596 11.128 36.2836 12.016 36.2836 13.216C36.2836 14.416 37.1596 15.304 38.3356 15.304ZM42.4218 7.48H43.3338V16H42.4218V7.48ZM44.8129 7.48H45.7249V16H44.8129V7.48ZM51.7048 10.432H52.6168V16H51.7048V15.424C51.2128 15.88 50.5408 16.144 49.7488 16.144C48.1528 16.144 46.8808 14.848 46.8808 13.216C46.8808 11.596 48.1528 10.288 49.7488 10.288C50.5408 10.288 51.2128 10.552 51.7048 11.008V10.432ZM49.8688 15.304C50.6008 15.304 51.2488 15.028 51.7048 14.356V12.076C51.2488 11.404 50.6008 11.128 49.8688 11.128C48.6928 11.128 47.7928 12.064 47.7928 13.216C47.7928 14.368 48.6928 15.304 49.8688 15.304ZM55.0188 11.344C55.5348 10.684 56.2788 10.3 57.1668 10.3V11.164C56.2548 11.188 55.5108 11.608 55.0188 12.376V16H54.1068V10.432H55.0188V11.344ZM61.3785 12.352C61.3785 14.356 62.1225 15.664 63.4425 16.888L62.8545 17.488C61.2705 16.192 60.4425 14.452 60.4425 12.352C60.4425 10.264 61.2705 8.524 62.8545 7.228L63.4425 7.828C62.1225 9.04 61.3785 10.36 61.3785 12.352ZM71.3581 7.84V12.508C71.3581 14.68 69.9661 16.144 67.8661 16.144C65.7661 16.144 64.3741 14.68 64.3741 12.508V7.84H65.3221V12.508C65.3221 14.104 66.3301 15.256 67.8661 15.256C69.3901 15.256 70.4101 14.104 70.4101 12.508V7.84H71.3581ZM75.7295 7.696C77.3375 7.696 78.7295 8.404 78.9335 10.084H77.9855C77.8055 9.112 77.1215 8.512 75.7895 8.512C74.5895 8.512 73.8095 9.052 73.8095 9.976C73.8095 10.696 74.3255 11.104 75.2975 11.296L76.6295 11.548C78.0935 11.836 78.9215 12.496 78.9215 13.696C78.9215 15.184 77.6975 16.144 75.8615 16.144C73.9055 16.144 72.6335 15.148 72.4535 13.384H73.3895C73.5815 14.608 74.4575 15.292 75.9095 15.292C77.1575 15.292 77.9495 14.728 77.9495 13.804C77.9495 13.156 77.5055 12.652 76.4735 12.472L74.9495 12.172C73.4975 11.896 72.8015 11.152 72.8015 10.036C72.8015 8.608 73.9775 7.696 75.7295 7.696ZM83.1482 7.84C85.6682 7.84 87.4562 9.508 87.4562 11.86C87.4562 14.284 85.6682 16 83.1482 16H80.2802V7.84H83.1482ZM83.1482 15.124C85.0922 15.124 86.4842 13.768 86.4842 11.86C86.4842 10.036 85.0922 8.716 83.1482 8.716H81.2282V15.124H83.1482ZM88.5164 7.228C90.1004 8.524 90.9284 10.264 90.9284 12.352C90.9284 14.452 90.1004 16.192 88.5164 17.488L87.9284 16.888C89.2484 15.664 89.9924 14.356 89.9924 12.352C89.9924 10.36 89.2484 9.04 87.9284 7.828L88.5164 7.228Z'
				fill='#022745'
			/>
			<defs>
				<filter
					id='filter0_d_8609_50280'
					x='6.88867'
					y='5.93359'
					width='6.22266'
					height='5.83464'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='1.16667' />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_8609_50280'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_8609_50280'
						result='shape'
					/>
				</filter>
				<linearGradient
					id='paint0_linear_8609_50280'
					x1='6.88867'
					y1='5.93359'
					x2='6.88867'
					y2='10.6006'
					gradientUnits='userSpaceOnUse'
				>
					<stop stopColor='white' />
					<stop
						offset='1'
						stopColor='#F0F0F0'
					/>
				</linearGradient>
				<clipPath id='clip0_8609_50280'>
					<rect
						x='8'
						y='5'
						width='14'
						height='14'
						rx='7'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
